import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconZoomIn = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--zoom-in")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M11,2 C15.9705627,2 20,6.02943725 20,11 C20,13.124779 19.2636898,15.0775836 18.0323074,16.6171757 L21.7071068,20.2928932 C22.0976311,20.6834175 22.0976311,21.3165825 21.7071068,21.7071068 C21.3165825,22.0976311 20.6834175,22.0976311 20.2928932,21.7071068 L20.2928932,21.7071068 L16.6171757,18.0323074 C15.0775836,19.2636898 13.124779,20 11,20 C6.02943725,20 2,15.9705627 2,11 C2,6.02943725 6.02943725,2 11,2 Z M11,4 C7.13400675,4 4,7.13400675 4,11 C4,14.8659932 7.13400675,18 11,18 C12.8904747,18 14.6059153,17.25059 15.8654514,16.0326404 L15.9428932,15.9428932 C15.9713525,15.914434 16.0011003,15.8880487 16.031949,15.8637373 C17.25059,14.6059153 18,12.8904747 18,11 C18,7.13400675 14.8659932,4 11,4 Z M11,7 C11.5522847,7 12,7.44771525 12,8 L12,8 L12,10 L14,10 C14.5128358,10 14.9355072,10.3860402 14.9932723,10.8833789 L15,11 C15,11.5522847 14.5522847,12 14,12 L14,12 L12,12 L12,14 C12,14.5128358 11.6139598,14.9355072 11.1166211,14.9932723 L11,15 C10.4477153,15 10,14.5522847 10,14 L10,14 L10,12 L8,12 C7.48716416,12 7.06449284,11.6139598 7.00672773,11.1166211 L7,11 C7,10.4477153 7.44771525,10 8,10 L8,10 L10,10 L10,8 C10,7.48716416 10.3860402,7.06449284 10.8833789,7.00672773 Z" id="icon--centivo--zoom-in"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1176.000000, -1423.000000)"/>
          <g id="Icon/zoom-in">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--zoom-in"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--zoom-in"/>
          </g>
      </g>
  </IconWrapper>
)
